import {
  Button,
  Fade,
  IconButton,
  MenuItem,
  ListItemText,
  Modal,
  TextField,
  Typography,
  Paper,
  Autocomplete,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import InputField from "../formElements/InputField";
import { listBankDetails } from "../../graphql";
import { API, graphqlOperation } from "aws-amplify";
import { updateBankDetails } from "../../graphql/mutations";
import { IfscFetch } from "../../library/IfscFetch";
import { useSelector } from "react-redux";
import { useListGroupMasterQuery } from "../../redux/apis/accountGroupMaster.api";
import { useCreateAccountMasterMutation, useUpdateAccountMasterMutation } from "../../redux/apis/accountMaster.api";
import { createBankDetailsCustom } from "../../graphql/postgress_graphql/customMutations";
import { showSuccessSnackbar } from "../snackBar/snakbar";

const AccountTypes = [
  { option: "Current Account", value: "1" },
  { option: "Savings Account", value: "2" },
  { option: "Overdraft", value: "3" },
];

function UpdateLedgerGroup({
  disableAll,
  open,
  setOpen,
  selectedRow,
  setUpdatedata,
  isVoucher,
  groups,
  groupName,
  options = [],
  defaultGroupID,
 setDisablePopup

}) {


  const [backdropOpen, setBackdropOpen] = useState(false);

  const initialState = {
    name: "",
    group: "",
    grName: "",
    bankName: "",
    bankAccountNo: "",
    ifscCode: "",
    accountType: "",
    branch: "",
    SwiftCode: "",
    bankdetailsid: '',
    errorStatus: {
      name: false,
      group: false,
      bankName: false,
      bankAccountNo: false,
      ifscCode: false,
      accountType: false,
      branch: false,
      SwiftCode: false
    },
    errorFields: {
      name: "",
      group: "",
      bankName: "",
      bankAccountNo: "",
      ifscCode: "",
      accountType: "",
      branch: "",
      SwiftCode: ""
    },
    edit: {
      name: false,
    },
  }


  const [state, setState] = useState(initialState);

  console.log(state)

  const [bankDetails, setBankDetails] = useState([]);


  const companyDetails = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );

  const handleAutoGenerateLedgerName = (e) => {
    if (
      state?.edit?.name === false &&
      state?.bankName?.length &&
      state.branch?.length &&
      state.bankAccountNo?.length
    ) {
      const value =
        state.bankName +
        "" +
        state.branch.slice(0, 4) +
        "" +
        state.bankAccountNo.toString().slice(-4);
      setState((prev) => ({
        ...prev,
        name: value,
      }));
    }
  };





  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "bankAccountNo") {
      if (
        !new RegExp(/^^\d{9,34}$/).test(e.target.value)
      ) {
        setState((prev) => ({
          ...prev,
          bankAccountNo: e.target.value,
          errorFields: {
            bankAccountNo: "Invalid Bank Account No",
          },
          errorStatus: {
            bankAccountNo: true,
          },
        }));
      } else if (/^0+$/.test(e.target.value)) {
        setState((prev) => ({
          ...prev,
          bankAccountNo: e.target.value,
          errorFields: {
            bankAccountNo: "Invalid Bank Account Number. It cannot be all zeros.",
          },
          errorStatus: {
            bankAccountNo: true,
          },
        }));
      } else {
        setState((prev) => ({
          ...prev,
          bankAccountNo: e.target.value,
          errorFields: {
            bankAccountNo: "",
          },
          errorStatus: {
            bankAccountNo: false,
          },
        }));
      }
    } else {
      const formatFieldName = (fieldName) =>
        fieldName
          .replace(/([A-Z])/g, " $1")
          .replace(/^\w/, (c) => c.toUpperCase());

      setState((prev) => {
        const newState = { ...prev, [name]: value };

        if (value.trim() === "") {
          newState.errorStatus = {
            ...prev.errorStatus,
            [name]: true,
          };
          newState.errorFields = {
            ...prev.errorFields,
            [name]: `${formatFieldName(name)} is required`,
          };
          newState.edit = {
            ...prev.edit,
            [name]: true,
          };
        } else {
          newState.errorStatus = {
            ...prev.errorStatus,
            [name]: false,
          };
          newState.errorFields = {
            ...prev.errorFields,
            [name]: "",
          };
          newState.edit = {
            ...prev.edit,
            [name]: false,
          };
        }

        return newState;
      });
    }


  };


  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: 24,
    // p: 4,
    outline: "none",
    // minWidth: "90%",
    // '@media (min-width:600px)': {
    //   minWidth: '500px',
    // },
    '@media (min-width:600px)': {
      width: 'auto',
    },
    width: "90%",
  };

  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };

    const isBankGroup = (defaultGroupID === 17 || defaultGroupID === 29);


    const anyBankFieldProvided = (
      (data["bankName"] && data["bankName"].trim() !== "") ||
      (data["bankAccountNo"] && data["bankAccountNo"].trim() !== "") ||
      (data["accountType"] && data["accountType"].trim() !== "") ||
      (data["ifscCode"] && data["ifscCode"].trim() !== "") ||
      (data["branch"] && data["branch"].trim() !== "")
    );


    const shouldValidateBankFields = isBankGroup && anyBankFieldProvided;

    Object.keys(data).map((key) => {

      if (key === "name") {
        if (!data[key] || data[key].trim().length === 0) {
          isvalid = false;
          obj.errorFields.name = "Name is required";
          obj.errorStatus.name = true;
        } else {
          obj.errorFields.name = "";
          obj.errorStatus.name = false;
        }
      }
      if (shouldValidateBankFields) {
        if (key === "bankName") {
          if (!data[key] || data[key].trim() === "") {
            isvalid = false;
            obj.errorFields.bankName = "Bank Name is required";
            obj.errorStatus.bankName = true;
          } else {
            obj.errorFields.bankName = "";
            obj.errorStatus.bankName = false;
          }
        }

        if (key === "bankAccountNo") {
          const accountNo = data[key]?.trim();
          if (!accountNo || accountNo === "") {
            isvalid = false;
            obj.errorFields.bankAccountNo = "Bank Account Number is required";
            obj.errorStatus.bankAccountNo = true;
          } else {
            const accountNoRegex = /^[0-9]{9,18}$/;
            if (!accountNoRegex.test(accountNo)) {
              isvalid = false;
              obj.errorFields.bankAccountNo = "Invalid Bank Account Number. It must be 9 to 18 digits.";
              obj.errorStatus.bankAccountNo = true;
            } else if (/^0+$/.test(accountNo)) {
              isvalid = false;
              obj.errorFields.bankAccountNo = "Invalid Bank Account Number. It cannot be all zeros.";
              obj.errorStatus.bankAccountNo = true;
            } else {
              obj.errorFields.bankAccountNo = "";
              obj.errorStatus.bankAccountNo = false;
            }
          }
        }


        if (key === "accountType") {
          if (!data[key] || data[key].trim() === "") {
            isvalid = false;
            obj.errorFields.accountType = "Bank Account Type is required";
            obj.errorStatus.accountType = true;
          } else {
            obj.errorFields.accountType = "";
            obj.errorStatus.accountType = false;
          }
        }

        if (key === "ifscCode") {
          if (!data[key] || data[key].trim() === "") {
            isvalid = false;
            obj.errorFields.ifscCode = "IFSC Code is required";
            obj.errorStatus.ifscCode = true;
          } else {
            if (data[key].match("^[A-Za-z]{4}0[A-Z0-9a-z]{6}$")) {
              obj.errorFields.ifscCode = "";
              obj.errorStatus.ifscCode = false;
            } else {
              isvalid = false;
              obj.errorFields.ifscCode = "Invalid IFSC";
              obj.errorStatus.ifscCode = true;
            }
          }
        }

        if (key === "branch") {
          if (!data[key] || data[key].trim() === "") {
            isvalid = false;
            obj.errorFields.branch = "Branch is required";
            obj.errorStatus.branch = true;
          } else {
            obj.errorFields.branch = "";
            obj.errorStatus.branch = false;
          }
        }
      } else {
        if (["bankName", "bankAccountNo", "accountType", "ifscCode", "branch"].includes(key)) {
          obj.errorFields[key] = "";
          obj.errorStatus[key] = false;
        }
      }
    });


    setState(obj);
    return isvalid;
  }
  async function listBankAccounts(selectedRow) {
    try {
      setBackdropOpen(true)
      const res = await API.graphql(graphqlOperation(listBankDetails));
      let obj = res.data.listBankDetails.filter((ele) => {
        if (ele.ledgeraccount === selectedRow.name) {
          return ele;
        }
      });
      setBankDetails(obj);
      setState((prev) => ({
        ...prev,
        name: obj?.[0]?.ledgeraccount || selectedRow.name,
        bankAccountNo: obj?.[0]?.bankaccountnumber,
        accountType: obj?.[0]?.bankaccounttype,
        ifscCode: obj?.[0]?.ifsccode,
        bankName: obj?.[0]?.bankname,
        branch: obj?.[0]?.branch,
        SwiftCode: obj?.[0]?.swiftcode,
        bankdetailsid: obj?.[0]?.bankdetailsid
      }));
    } catch (error) {
      console.log("error", error);
    } finally {
      setBackdropOpen(false)
    }
  }


  const [updateAccountMaster] = useUpdateAccountMasterMutation()

  async function saveEditChanges() {
    const { name, bankName, bankAccountNo, ifscCode, accountType, branch } =
      state;
    const formData = { name, bankAccountNo, ifscCode, accountType, branch };
    if (formValidation(formData)) {
       const  accountsid = state.bankdetailsid ? state.bankdetailsid : selectedRow.accountsID

      if (defaultGroupID == 17 || defaultGroupID == 29) {
        const commonUpdateInput = {
          accountname: state.name,
          accountgroupid: state.group,
          accountsid: accountsid,
          accounttypecd: "BS",
          hsnsaccode: 0,
          companybranchid: 0,
          accounttypeflag: 0,
          is_active: 1,
        }

        const accountUpdate = updateAccountMaster({
          updateAccountMasterInput: commonUpdateInput
        })

        const bankEntry = {
          bankaccountnumber: state.bankAccountNo,
          bankname: state.bankName,
          branch: state.branch,
          ifsccode: state.ifscCode,
          notes: "",
          objectid: companyDetails?.companyid,
          objecttype: "COMPANY",
          ledgeraccount: state.name,
          bankaccounttype: state.accountType,
          cash: 0,
          swiftcode: state.SwiftCode,
          expiredtimestamp: 0,
          companybranchid: 0,
          bankdetailsid:accountsid,
          upi: "",
        }

        const res = await API.graphql(
          graphqlOperation(createBankDetailsCustom, {
            createBankDetailsInput: bankEntry,
          })
        );
      }
      setOpen(false);
      showSuccessSnackbar("Account Updated Successfully");
      setState(initialState);
    }
  }

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      setState(initialState);
      setDisablePopup(false)

    }
  };
  let [GrpOptions, setGrpOptions] = useState([...options]);

  console.log(GrpOptions,"###groups")
  const { data: groupData, isLoading, isError } = useListGroupMasterQuery()
  function createKey(obj) {
    const newOption = {
      name: obj?.accountgroupname,
      value: obj?.accountgroupid,
      DisplayOrderNumber: obj?.displayordernumber,
      AccountTypeCD: obj?.accounttypecd,
    };
    setGrpOptions((prevOptions) => [...prevOptions, newOption]);
  }
  useEffect(() => {
    if (open) {
      if ((defaultGroupID === 17 || defaultGroupID === 29)) {
        listBankAccounts(selectedRow);
        setState((prev) => ({
          ...prev,
          grName: selectedRow?.id,
        }));
      }
      setState((prev) => ({
        ...prev,
        name: selectedRow.name,
        group: selectedRow?.parent ? selectedRow?.parent : selectedRow?.value,
        grName: selectedRow?.id,
      }));

      if (groupData) {
        groupData?.map((obj) => {
          createKey(obj);
        });
      }

    }
    return () => {
      setGrpOptions([]);
    };
  }, [open, selectedRow]);
  return (
    <Box>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >

        <Fade in={open}>
          <Paper sx={style}>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={backdropOpen}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {selectedRow.category == "ledger"
                    ? (disableAll == true
                      ? "View Account"
                      : "Edit Account")
                    : "Edit Group"}
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: "15px",
                // height:{xs:"400px",sm:'auto'},
              }}
            >
              <Box sx={{}}>
                {/* {(defaultGroupID !== 17 && defaultGroupID !== 29) ? ( */}

                {/* ) : ( */}
                <>
                  <Box
                    sx={{
                      marginBottom: "20px",
                      padding: { xs: "10px 0px", sm: "10px 10px" },
                      borderRadius: "12px",
                      boxShadow:
                        "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
                      ":hover": {
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                      },
                      transition: "all 1s ease-in-out",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: { sm: "flex-start" },
                        flexWrap: { xs: "wrap", md: "nowrap" },
                        flexDirection: { xs: "column", sm: "row" },
                        marginBottom: "0px",
                      }}
                    >
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={
                            state.errorStatus.ifscCode == true ? true : false
                          }
                          disabled={disableAll}
                          label="IFSC Code"
                          name="ifscCode"
                          id="ifscCode"
                          fullWidth
                          value={state.ifscCode}
                          onBlur={handleAutoGenerateLedgerName}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase();
                            setState((prev) => ({
                              ...prev,
                              ifscCode: value,
                            }));
                            if (value === "") {
                              setState((prev) => ({
                                ...prev,
                                ifscCode: value,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  ifscCode: true,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  ifscCode: "IFSC Code is required",
                                },
                              }));
                            } else {
                              if (value.match("^[A-Za-z]{4}0[A-Z0-9a-z]{6}$")) {
                                setBackdropOpen(true)
                                setState((prev) => ({
                                  ...prev,
                                  ifscCode: value,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    ifscCode: false,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    ifscCode: "",
                                  },
                                }));

                                IfscFetch(value)
                                  .then((e) => {
                                    setState((prev) => ({
                                      ...prev,
                                      bankName: e.data.bankName,
                                      branch: e.data.branchName,
                                    }));
                                    setBackdropOpen(false)
                                  })
                                  .catch((e) => {
                                    setBackdropOpen(false)
                                    console.log("error", e);
                                  });
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  ifscCode: value,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    ifscCode: true,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    ifscCode: "Invalid IFSC",
                                  },
                                }));
                                setState((prev) => ({
                                  ...prev,
                                  bankName: "",
                                  branch: "",
                                }));
                              }
                            }
                          }}
                          size="small"
                          sx={{
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.ifscCode}
                        </Typography>

                      </Box>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={
                            state.errorStatus.bankName === true ? true : false
                          }
                          disabled={disableAll}
                          name="bankName"
                          label="Bank Name"
                          variant="outlined"
                          size="small"
                          fullWidth
                          value={state.bankName}
                          onBlur={handleAutoGenerateLedgerName}
                          onChange={(e) => {
                            const name = e.target.name;
                            const value = e.target.value;
                            if (value === "") {
                              setState((prev) => ({
                                ...prev,
                                ["bankName"]: value,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  ["bankName"]: true,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  ["bankName"]: "Bank Name is required",
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                ["bankName"]: value,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  ["bankName"]: false,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  ["bankName"]: "",
                                },
                              }));
                            }
                          }}
                          sx={{
                            ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                            {
                              fontSize: "14px",
                            },
                            label: {
                              fontSize: "14px",
                            },
                            ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                              fontSize: "14px",
                            },
                            ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                            {
                              color: "input.font",
                            },
                            ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                              borderColor: "input.border",
                            },
                            ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                            {
                              color: "input.font",
                            },
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        ></TextField>
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.bankName}
                        </Typography>

                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: { sm: "flex-start" },
                        flexWrap: { xs: "wrap", md: "nowrap" },
                        flexDirection: { xs: "column", sm: "row" },
                        marginBottom: "0px",
                      }}
                    >
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={
                            state.errorStatus.branch == true ? true : false
                          }
                          disabled={disableAll}
                          label="Branch"
                          name="branch"
                          id="branch"
                          fullWidth
                          value={state.branch}
                          onBlur={handleAutoGenerateLedgerName}
                          onChange={(e) => handleChange(e)}
                          size="small"
                          sx={{
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.branch}
                        </Typography>

                      </Box>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <Box sx={{ mb: 2 }}>
                          <TextField
                            error={
                              state.errorStatus.bankAccountNo == true
                                ? true
                                : false
                            }
                            disabled={disableAll}
                            label="Bank Account Number"
                            name="bankAccountNo"
                            id="bankAccountNo"
                            fullWidth
                            onChange={(e) => handleChange(e)}
                            onBlur={handleAutoGenerateLedgerName}
                            value={state.bankAccountNo}
                            size="small"
                            sx={{
                              ".css-wgai2y-MuiFormLabel-asterisk": {
                                color: "danger.main",
                              },
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "danger.main",
                            }}
                          >
                            {state?.errorFields.bankAccountNo}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: { sm: "flex-start" },
                        flexWrap: { xs: "wrap", md: "nowrap" },
                        flexDirection: { xs: "column", sm: "row" },
                        marginBottom: "0px",
                      }}
                    >
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        {/* swift code */}
                        <TextField
                          error={
                            state.errorStatus.SwiftCode == true ? true : false
                          }
                          disabled={disableAll}
                          label="Swift Code"
                          name="SwiftCode"
                          id="SwiftCode"
                          fullWidth
                          value={state.SwiftCode}
                          onChange={(e) => handleChange(e)}
                          size="small"
                          sx={{
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.SwiftCode}
                        </Typography>
                      </Box>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={state.errorStatus.accountType === true}
                          disabled={disableAll}
                          select
                          label="Bank Account Type"
                          name="accountType"
                          id="accountType"
                          fullWidth
                          value={state.accountType}
                          onChange={(e) => {
                            const name = e.target.name;
                            const value = e.target.value;

                            if (value === "") {
                              setState((prev) => ({
                                ...prev,
                                ["accountType"]: value,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  ["accountType"]: true,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  ["accountType"]: "Bank Account Type is required",
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                ["accountType"]: value,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  ["accountType"]: false,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  ["accountType"]: "",
                                },
                              }));
                            }
                          }}
                          size="small"
                          sx={{
                            "& .MuiSelect-select": {
                              fontSize: "0.80rem",
                            },
                            "& .css-1rtm8vu-MuiTypography-root": {
                              fontSize: "0.80rem",
                            },
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                          SelectProps={{
                            MenuProps: {
                              PaperProps: {
                                sx: {
                                  "& .MuiMenuItem-root": {
                                    fontSize: "0.75rem",
                                  },
                                },
                              },
                            },
                          }}
                        >
                          {AccountTypes.map((item) => (
                            <MenuItem key={item.value} value={item.value}>
                              <ListItemText
                                sx={{ margin: "0px" }}
                                primary={item.option}
                              />
                            </MenuItem>
                          ))}
                        </TextField>






                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.accountType}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </>
                {/* )} */}
                {isVoucher === true && (
                  <Box sx={{ display: "flex" }}>
                    <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                      <InputField
                        name="name"
                        required={true}
                        disable={disableAll}
                        state={state}
                        placeholder={
                          selectedRow.category == "ledger"
                            ? ((disableAll == true)
                              ? "Ledger Name"
                              : "Edit Ledger Name")
                            : "Edit Group Name"
                        }
                        size="small"
                        type="text"
                        value={state.name}
                        onChange={(e) => handleChange(e)}
                      />
                    </Box>
                    <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                      <Autocomplete
                        options={GrpOptions}
                        disabled
                        getOptionLabel={(option) => option?.name || ''}
                        value={
                          GrpOptions.find((option) => option?.value == state.group) ||
                          null
                        }
                        // value={state.group}
                        onChange={(event, newValue) => {
                          // Set the selected value into the state
                          if (newValue) {
                            setState((prev) => ({
                              ...prev,
                              group: newValue.value,
                              grName: newValue.name,
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              group: '',
                              grName: '',
                            }));
                          }
                        }}
                        renderOption={(props, option) => (
                          <li {...props} key={option.value}>
                            {option.name}
                          </li>
                        )}
                        isOptionEqualToValue={(option, value) => option.value === value}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={state.errorStatus.group}
                            required={true}
                            name="group"
                            label="Under Group"
                            variant="outlined"
                            size="small"
                            fullWidth
                            InputLabelProps={{
                              shrink: true,
                            }}
                            sx={{
                              ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                                fontSize: "14px",
                              },
                              label: {
                                fontSize: "14px",
                              },
                              ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                                fontSize: "14px",
                              },
                              ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                                color: "input.font",
                              },
                              ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                                borderColor: "input.border",
                              },
                              ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                                color: "input.font",
                              },
                              ".css-14qz1ij-MuiListItemText-root": {
                                margin: "0px",
                              },
                              ".css-wgai2y-MuiFormLabel-asterisk": {
                                color: "danger.main",
                              },
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                // padding : "15px",
                // width:'100%',
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Button
                onClick={handleClose}
                variant="outlined"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Cancel
              </Button>
              {disableAll !== true && (
                <Button
                  onClick={saveEditChanges}
                  variant="contained"
                  sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
                >
                  Save
                </Button>
              )}
            </Box>
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
}

export default UpdateLedgerGroup;
